import { GameComponent } from '@Core/GameComponent/GameComponent';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { AnimatedSprite, Assets, Point, Rectangle, Texture } from 'pixi.js';
import { GameScene } from '..';
import AssetsLoadManager from '../Loader/AssetsLoadManager';
import { SceneNames } from '../SceneNames';
import { STARTUP_LOGO_CONFIG } from './StartupLogoConfig';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';

export class StartupLogo extends GameComponent {
    private logoAnimation: AnimatedSprite;
    constructor(public scene: GameScene) {
        super(scene);
        Logger.log(LoggerLevel.Constructor, { class: SceneNames.LOGO_SCENE, message: 'StartupLogo constructor', source: LoggerSource.Game });
    }

    public init(): void {
        this.preload();
    }

    public preload(): void {
        // TODO MAKE LOADING FROM GAME FILES?
        const { animationConfig, logoAnimationPath, logoAnimationFileName } = STARTUP_LOGO_CONFIG;
        AssetsLoadManager.initialize(this.scene);
        AssetsLoadManager.loadPreloaderAnimation(animationConfig.key!, logoAnimationPath, logoAnimationFileName, this.onPreloaderAnimationLoaded.bind(this));
    }

    public create(): void {}

    public onResize = (): void => {
        const logoOffset = 60;
        this.logoAnimation.position = new Point(this.scene.screen.width / 2, this.scene.screen.height / 2);
        this.logoAnimation.scale = 1.5;
        if (this.logoAnimation.width + logoOffset > this.scene.screen.width) {
            const ratio = this.logoAnimation.height / this.logoAnimation.width;
            this.logoAnimation.width = this.scene.screen.width - logoOffset;
            this.logoAnimation.height = (this.scene.screen.width - logoOffset) * ratio;
        }
    };

    private onPreloaderAnimationLoaded(): void {
        this.createLogo();
        AssetsLoadManager.loadFiles();
    }

    public createLogo(): void {
        const { textureConfig, animationConfig } = STARTUP_LOGO_CONFIG;

        const { frameWidth, frameHeight, startFrame, endFrame } = textureConfig;

        const texture = Assets.get(animationConfig.key);
        const columns = Math.floor(texture.width / frameWidth);
        const frames: Texture[] = [];

        for (let i = startFrame; i <= endFrame; i++) {
            const index = i - 1;

            const x = (index % columns) * frameWidth;
            const y = Math.floor(index / columns) * frameHeight;

            frames.push(
                new Texture({
                    source: texture.source,
                    frame: new Rectangle(x, y, frameWidth, frameHeight)
                })
            );
        }

        const sprite = new AnimatedSprite(frames);
        this.scene.stage.addChild(sprite);
        sprite.position = new Point(this.scene.screen.width / 2, this.scene.screen.height / 2);
        sprite.anchor = 0.5;
        sprite.animationSpeed = animationConfig.frameRate / 60;
        sprite.loop = false;
        sprite.play();
        sprite.onComplete = () => {
            EventsCenter.emit(EGameEvents.PRELOADER_LOGO_ANIMATION_COMPLETED);
        };
        this.logoAnimation = sprite;
        this.game.gameStore.set(EGameStoreKeys.PreloaderState, { active: true, currentScene: SceneNames.LOGO_SCENE, showPreloaderInfo: false }, true);
        this.onResize();
        window.addEventListener('resize', this.onResize);
    }

    public destroy(): void {
        removeEventListener('resize', this.onResize);
        this.logoAnimation.destroy();
    }
}
